export default "__VITE_ASSET__917486e1__"